import React from 'react';
import { compose, withProps } from 'recompose';
import { SelectBox } from 'components/core/Form';
import { addDays, isSameDay } from 'date-fns';

import './UnitDropdownDatepicker.scss';

const DEFAULT_OPTION = {
	display: 'Select a date',
	disabled: true,
	value: ''
};

export const enhance = compose(
	withProps(({ reservationWindow, closures, today }) => {
		const options = Array
		// create an array the length of the window made of dates
		.from({ length: reservationWindow + 1 }, (_, k) => addDays(today, k))
		// map days into objects with value and display keys
		.map((d) => ({
			value: d.toLocaleDateString('en-US'),
			disabled: closures.some((c) => isSameDay(c, d)),
			display: d.toLocaleDateString('en-US', {
				weekday: 'long',
				month: 'long',
				day: 'numeric'
			})
		}))
		.reduce((a, d, i) => {
			// add dividers to weeks
			if (d.display.includes('Sunday')) {
				return [
					...a,
					{
						value: i,
						display: '---------',
						disabled: true
					},
					d
				];
			}
			return [...a, d];
		}, []);
		return {
			options: [DEFAULT_OPTION, ...options]
		};
	})
);

export const UnitDropdownDatepicker = ({ ...props }) => (
	<SelectBox
		id="unit-reservation-date-dropdown"
		className="dropdown-datepicker"
		errorMessage={props.errorMessage}
		{...props}
	/>
);

UnitDropdownDatepicker.propTypes = {
	...SelectBox.propTypes
};

export default enhance(UnitDropdownDatepicker);
